
<template>
    <reconciliation-step-template 
        :nextStep="nextStep" 
        :previousStep="previousStep" 
        @next="goToNextStep"
        @previous="$emit('previous')"
        :loading="loading">
        
        <template #content>
            <el-form 
                ref="step3Form" 
                label-position="top"
                :model="formStep" 
                :inline-message="true"  
                label-width="120px">

                <p class="fs-3 semibold mt-4 mb-2">1 - {{ $l10n.__("Définissez la colonne de date de transaction") }}</p>
                <el-form-item label="" prop="dateColumn" :error="errors.get('dateColumn')">
                    <div class="step-container-table border-black" v-loading="loading">
                        <table-selectable-columns 
                            :lines="csv"
                            v-model="value.template.date.columns"
                            :max="1"
                        />
                    </div>
                </el-form-item>
                
                <p class="fs-3 semibold mt-4 mb-2">2 - {{ $l10n.__("Définissez le format de la date de transaction") }}</p>
                <el-form-item label="" prop="dateFormat" :error="errors.get('dateFormat')">
                    <select-input 
                        mode="edit"
                        v-model="value.template.date.arguments.format"
                        :options="dateFormats"
                    />
                </el-form-item>
            </el-form>
        </template>
    </reconciliation-step-template>
</template>

<script>
    import TableSelectableColumns from 'vcomponents/utilities/TableSelectableColumns.vue'
    import ImportStepsMixins from './ImportStepsMixins'
    import BankReconciliationImport from 'api/bankreconciliationImport'
    import FormMixin from 'mixins/FormMixins'
    import SelectInput from 'vcomponents/inputs/SelectInput.vue'

    export default {
        mixins: [ImportStepsMixins, FormMixin],
        data(){
            return {
                selectedColumns: [],
                dateFormats: [
                    {
                        label: this.$l10n.__('JJMMAAAA'),
                        value: 'dmY'
                    },
                    {
                        label: this.$l10n.__('JJ/MM/AAAA'),
                        value: 'd/m/Y'
                    },
                    {
                        label: this.$l10n.__('JJ/MM/AA'),
                        value: 'd/m/y'
                    },
                    {
                        label: this.$l10n.__('AAAA-MM-JJ'),
                        value: 'Y-m-d'
                    },
                    {
                        label: this.$l10n.__('AAAAMMJJ'),
                        value: 'Ymd'
                    },
                ],
                loading: true,
                formStep: {
                    dateColumn: this.value.template.date.columns,
                    dateFormat: this.value.template.date.arguments.format
                }
            }
        },
        created(){
            BankReconciliationImport.getTemplate(this.idImport).then(response => {
                this.$emit('update-csv', response.csv)
                this.$emit('update-import-id', this.idImport)
                if(Object.keys(response.template).length > 0){
                    this.value.template = {...this.value.template, ...response.template}
                }
                this.loading = false
            }).catch(error => {
                Push.error(error, false)
            })
        },
        methods: {
            goToNextStep(){
                this.checkMinColumns('date', 1) ? this.$emit('next') : false
            }
        },
        components: {
            TableSelectableColumns,
            SelectInput
        }
    }
</script>

<style scoped>

</style>
